var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{class:_vm.homePath ? 'home-path' : 'internal-path'},[_c('router-view')],1),_c('ConfirmDialog',{ref:"confirmDialog"}),_c('LogoutMessageDialog',{ref:"logoutMessageDialog"}),_c('AppToaster')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }